import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Pagination = ({ fetched, loading ,totalResults, currentPage, onPageChange }) => {
  const recordPerPage = 10;
  const maxVisiblePages = 5;
  const totalPages = Math.ceil(totalResults / recordPerPage)

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // Adjust startPage when near the last pages
  if (totalPages > maxVisiblePages && endPage === totalPages) {
    startPage = totalPages - maxVisiblePages + 1;
  }

  // Adjust startPage when near the first pages
  if (startPage < 1) {
    startPage = 1;
  }

  const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

  const totalCount = () => {
    if (loading) return 'Searching...';
    if (fetched) return `${totalResults === 0  ? 'No' : totalResults } consultant${totalResults > 1  ? 's' : '' } found`
    return ''
  }

  const previousPage = () => {
    if (currentPage - 1 < 1) return 1;
    return currentPage - 1
  }

  const nextPage = () => {
    if (currentPage + 1 > totalPages) return currentPage;
    return currentPage + 1
  }

  return (
    <div>
      <h5 className="fw-bolder">{totalCount()}</h5>
      <div className={ totalResults > recordPerPage ? 'pagination' : 'd-none pagination'}>

        <button
          type="submit"
          className={'btn btn-primary'}
          onClick={() => onPageChange(1)}
        >
          <FontAwesomeIcon icon="angle-double-left" />
        </button>
        <button
          type="submit"
          className={'btn btn-primary'}
          onClick={() => onPageChange(previousPage())}
        >
          <FontAwesomeIcon icon="angle-left" />
        </button>
        {pageNumbers.map((number) => (
          <button
            type="submit"
            key={number}
            className={ currentPage === number ? 'btn badge' : 'btn btn-primary'}
            onClick={() => onPageChange(number)}
          >
            {number}
          </button>
        ))}
        <button
          type="submit"
          className={'btn btn-primary'}
          onClick={() => onPageChange(nextPage())}
        >
          <FontAwesomeIcon icon="angle-right" />
        </button>
        <button
          type="submit"
          className={'btn btn-primary'}
          onClick={() => onPageChange(totalPages)}
        >
          <FontAwesomeIcon icon="angle-double-right" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
